import type { ReactNode } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

const DISABLED_HINT_TRIGGER_CLASS =
  'inline-flex cursor-not-allowed rounded-md outline-none focus-visible:ring-2 focus-visible:ring-ring/50 [&_button:disabled]:pointer-events-none';

interface DisabledHintProps {
  hint: string;
  ariaLabel: string;
  children: ReactNode;
}

export function DisabledHint({ hint, ariaLabel, children }: DisabledHintProps) {
  return (
    <Tooltip>
      <TooltipTrigger
        render={<span />}
        tabIndex={0}
        aria-label={`${ariaLabel}: ${hint}`}
        className={DISABLED_HINT_TRIGGER_CLASS}
      >
        {children}
      </TooltipTrigger>
      <TooltipContent>{hint}</TooltipContent>
    </Tooltip>
  );
}
